import React, { useEffect, useState } from 'react';
import { Card } from '../components/ui';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useTranslation } from '../hooks/useTranslation';
import { Home, Search, ArrowBack, HelpOutline } from '../mui-icons';
import iconImage from '../assets/icon.webp';
import './NotFoundPage.css';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    // Redirect after 10 seconds
    const redirectTimer = setTimeout(() => {
      navigate('/');
    }, 10000);

    // Update counter every second
    const countdownInterval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // Clear timers when component unmounts
    return () => {
      clearTimeout(redirectTimer);
      clearInterval(countdownInterval);
    };
  }, [navigate]);

  return (
    <div className="not-found-page surface-marketing">
      <Header />

      <section className="not-found-section">
        <div className="container not-found-container">
          {/* Ícone Animado */}
          <div className="not-found-icon-wrapper">
            <div className="not-found-circle-1"></div>
            <div className="not-found-circle-2"></div>
            <img src={iconImage} alt="PersonalNutri" className="not-found-icon" />
          </div>

          {/* Código 404 */}
          <div className="not-found-code">
            <span className="code-digit">4</span>
            <span className="code-digit code-zero">0</span>
            <span className="code-digit">4</span>
          </div>

          {/* Mensagem */}
          <h1 className="not-found-title">{t('notFound.hero.title')}</h1>
          <p className="not-found-text">
            {t('notFound.hero.subtitle')}
          </p>
          
          {/* Contador de Redirecionamento */}
          <div className="redirect-notice">
            <p>
              {t('notFound.redirect.text')} <span className="countdown-number">{countdown}</span> {t('notFound.redirect.seconds')}{countdown !== 1 ? 's' : ''}...
            </p>
          </div>

          {/* Sugestões */}
          <div className="not-found-suggestions">
            <Card variant="marketing" className="suggestion-card">
              <Search sx={{ fontSize: 32, color: '#4CAF50' }} />
              <h3>{t('notFound.suggestions.url.title')}</h3>
              <p>{t('notFound.suggestions.url.description')}</p>
            </Card>
            <Card variant="marketing" className="suggestion-card">
              <HelpOutline sx={{ fontSize: 32, color: '#4CAF50' }} />
              <h3>{t('notFound.suggestions.help.title')}</h3>
              <p>{t('notFound.suggestions.help.description')}</p>
            </Card>
          </div>

          {/* Botões de Ação */}
          <div className="not-found-actions">
            <button onClick={() => navigate(-1)} className="btn-404 btn-secondary-404">
              <ArrowBack />
              {t('notFound.actions.back')}
            </button>
            <button onClick={() => navigate('/')} className="btn-404 btn-primary-404">
              <Home />
              {t('notFound.actions.home')}
            </button>
            <button onClick={() => navigate('/support')} className="btn-404 btn-outline-404">
              <HelpOutline />
              {t('notFound.actions.support')}
            </button>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NotFoundPage;

